import { useEffect, useState } from "react";
import { getAllUsers } from "../../../../services/api/fytnServices";

export const useFetchUser = (reFetch, id,reload,licenses,setLicenses,setRefetch) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);     

  useEffect(() => {
  const fetchUserDetail = async () => {
    try {
      const res = await getAllUsers(id);

setLicenses({remaining:res.data.meta.remaining_licenses,total:res.data.meta.total_licenses})
      const mappedUsers = res.data.users.map((user,index) => ({
        id: user.USER_MASTER_ID||index,
        USER_NAME: user.USER_NAME,
        USER_AGE: user.USER_AGE,
        USER_COMPANY_HIGHER_EDUCATION: user.USER_COMPANY_HIGHER_EDUCATION || "N/A",
        USER_EMAIL: user.USER_EMAIL,
        USER_PHONE_NO: user.USER_PHONE_NO,
        COMPANY_NAME: user.COMPANY_NAME || "N/A",
        USER_COMPANY_ROLE: user.USER_COMPANY_ROLE || "N/A",
        CREATED_ON: user.CREATED_ON,
        TOKEN: user.TOKEN,
        USER_RESPONCE: user.USER_RESPONCE,
        INSTITUTION_NAME: user.INSTITUTION_NAME,
        USER_TYPE: user.USER_TYPE,
        USER_GRADE: user.USER_GRADE,
        USER_COURSE: user.USER_COURSE
      }));

      // Sort users: active users first, then by test submission status
      const sortedUsers = mappedUsers.sort((a, b) => {
        // First priority: Active users (no USER_RESPONCE means active/not submitted test)
        const aActive = !a.USER_RESPONCE?.value;
        const bActive = !b.USER_RESPONCE?.value;
        
        if (aActive !== bActive) {
          return aActive ? -1 : 1; // Active users first
        }
        
        // Second priority: Sort by creation date (newest first)
        const aDate = new Date(a.CREATED_ON || 0);
        const bDate = new Date(b.CREATED_ON || 0);
        return bDate - aDate;
      });

      setRows(sortedUsers);
      setRefetch(false);
    } catch (error) {
      console.log("Error reading session data:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  fetchUserDetail();
}, [reFetch,reload,]);


  return {rows, loading, error };
};
